export default __webpack_public_path__ + "static/media/Snd5.ae51497e.mp3";